// Creates a timer function that measures elapsed time in seconds.
// Returns a function that, when called, gives the elapsed time as a number.
//
// Basic usage
// const timer = measureDiffSecs();
// // Do some operations...
// const elapsedTime = timer();
export const measureDiffSecs = () => {
  // Capture the start time when the function is called
  const startTime = performance.now(); // Return a function that calculates the elapsed time

  return () => {
    const endTime = performance.now(); // Convert milliseconds to seconds

    return ((endTime - startTime) / 1000).toFixed(2);
  };
};